import lodash from "lodash";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { isDefined } from "./../../wix-rich-content-common/Utils/is-defined.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isTextStylesMatchDocumentStylesResolver = TiptapContentResolver.create(
  (content = [], { styles, converters }) => {
    const currentNode = content.filter((node) => {
      return node.type.name === Node_Type.HEADING || node.type.name === Node_Type.PARAGRAPH;
    });
    let stylesMatched = true;
    if (currentNode.length === 1) {
      const ricosCurrentNode = converters.fromPmNode(currentNode[0].toJSON());
      const currentNodeDocumentsStyles = styles.getDocumentStyle().getDecorations(ricosCurrentNode);
      const textsDecorations = (ricosCurrentNode?.nodes ?? []).filter((node) => {
        return node.type === Node_Type.TEXT;
      }).map((node) => {
        return node.textData?.decorations;
      }).flat().filter(isDefined);
      stylesMatched = textsDecorations.every((decoration) => {
        const currentDocumentStyleDecoration = currentNodeDocumentsStyles.find((documentStyle) => {
          return documentStyle.type === decoration.type;
        });
        if (currentDocumentStyleDecoration) {
          const removeNullReplacer = (key, value) => value === null ? void 0 : value;
          const cleanDecoration = JSON.parse(JSON.stringify(decoration, removeNullReplacer));
          const cleaneDcurrentDocumentStyleDecoration = JSON.parse(
            JSON.stringify(currentDocumentStyleDecoration, removeNullReplacer)
          );
          if (currentDocumentStyleDecoration) {
            if (!lodash.isEqual(cleaneDcurrentDocumentStyleDecoration, cleanDecoration)) {
              return false;
            }
          }
        } else {
          return false;
        }
        return true;
      });
    }
    return stylesMatched;
  }
);
export {
  isTextStylesMatchDocumentStylesResolver
};
//# sourceMappingURL=is-text-styles-match-document-styles.js.map
